module.exports = __webpack_public_path__ + "images/purchase_hero@3x.jpg?6160227e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/purchase_hero@3x.jpg
// module id = 691
// module chunks = 7